import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

class FullBannerCarousel extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.init();
  }

  init() {
    // Esperar a que el elemento esté conectado al DOM
    if (this.isConnected) {
      this.initSwiper();
    } else {
      // Si no está conectado, esperar a que se conecte
      this.addEventListener('connectedCallback', () => this.initSwiper());
    }
  }

  initSwiper() {
    // Verificar si el elemento existe
    const swiperElement = this.querySelector('[data-banner-swiper]');
    if (!swiperElement) return;
    
    this.swiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      centeredSlides: true,
      
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // Configuración para mostrar solo una diapositiva a la vez
      watchSlidesProgress: true,
      slideVisibleClass: 'swiper-slide-visible',
      slidesPerGroup: 1,
      loopAdditionalSlides: 0,
      loopedSlides: 1,
      threshold: 10,
      // Optimización de rendimiento
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1
      },
      // Aplicar CSS de manera más eficiente
    });
  }

  // Método para limpiar recursos cuando el componente se desconecta
  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

// Registrar el componente web
customElements.define('full-banner-carousel', FullBannerCarousel);

// Exportar la clase para posible uso en otros módulos
export default FullBannerCarousel;